import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '../../overrides/Typography';
import Chevron from '../../../assets/icons/grv-chevron-down.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.spoon.yellow[40],
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(1),
  },
  content: {
    display: 'flex',
    flex: '1 1 auto',
  },
  textContent: {
    marginLeft: theme.spacing(1.5),
  },
  chevronRight: {
    transform: 'rotate(-90deg)',
  },
  linkContainer: {
    marginTop: theme.spacing(2),
    cursor: 'pointer',
  },
}));

const InfoBlockMessage = ({
  text,
  linkText,
  children,
  icon,
  onClickHandler,
  onKeyPressHandler,
  screenReaderText = '',
  classes: classesOverride,
  role = 'dialog',
  altIconText = ''
}) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <Box className={classes.root} variant="small2Normal">
      <Box className={classes.content}>
        <Box>
          <Box height={24} width={24} component="img" src={icon} {...(altIconText ? { alt: altIconText } : {})} />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          className={classes.textContent}>
          {(text || children) && (
            <Box>
              <Typography
                variant="small2Normal"
                role={role}
                aria-label={screenReaderText}
                {...(screenReaderText ? { tabindex:"0" }: {})}
                >
                {text || children}
              </Typography>
            </Box>
          )}
          {linkText && (
            <Box
              display="flex"
              className={classes.linkContainer}
              onClick={onClickHandler}
              >
              <Typography
                variant="small2Semibold"
                role="link"
                aria-label={linkText}
                 {...(linkText ? { tabindex:"0" }: {})}
                 onKeyPress={onKeyPressHandler}
                >
                {linkText}
              </Typography>
              <Box display="flex">
                <Box
                  component="img"
                  src={Chevron}
                  className={classes.chevronRight}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default InfoBlockMessage;
